import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { IonRow, IonText } from "@ionic/react";
import { SEO, SpinningLogo, Loading } from "../components";
import { layoutConfigs } from "../layouts/layoutConfig";
import { seoIntroPage } from "../layouts/seoConfig";

export const Intro = (props) => {
  const { isMobile } = props;
  const [showIntroContent, setShowIntroContent] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timers = [];

    const showContentTimer = setTimeout(() => {
      setShowIntroContent(true);
    }, 500);
    timers.push(showContentTimer);

    return () => {
      timers.forEach((timer) => clearTimeout(timer));
    };
  }, []);

  const className = "logos-intro";

  const handleCanPlayThrough = () => {
    setLoading(false); // Когда видео готово к воспроизведению, меняем состояние загрузки
  };

  return (
    <>
      <SEO
        title={seoIntroPage?.title}
        description={seoIntroPage?.description}
        keywords={seoIntroPage?.keywords}
        ogImage="/assets/og_image/igor_swara.jpg"
      />
      <div id="IntroPage" className="intro-page">
        <video
          preload="auto" // Загрузка видео для более быстрой загрузки
          autoPlay
          loop
          muted
          playsInline // Этот атрибут предотвращает открытие видео в плеере на мобильных устройствах
          onCanPlayThrough={handleCanPlayThrough} // Используем onCanPlayThrough
          style={loading ? { visibility: "hidden" } : {}}
        >
          <source
            src={
              isMobile
                ? "/assets/visuals_mobile.mp4"
                : "/assets/visuals_hardcorebuddhist.mp4"
            }
            type="video/mp4"
          />
        </video>
        <div
          className="intro-text title-shine"
          style={loading ? { visibility: "hidden" } : {}}
        >
          <h1>IGOR SWARA</h1>
          <h2>
            One artist
            <span className="intro-text-symbol"> &#10023; </span>
            Three portals <span className="intro-text-symbol"></span>
          </h2>
          <h3>Exploring electronic soundscapes since 2007.</h3>
        </div>
        {loading ? (
          <Loading />
        ) : (
          <div
            className={`intro-content ${
              showIntroContent ? "intro-active" : ""
            }`}
          >
            {Object.values(layoutConfigs)?.map((project, index) => (
              <NavLink key={index} to={project.path} className="project-link">
                <SpinningLogo className={className} logos={project.logos} />
                <IonRow className="title-row-intro">
                  <IonText className="title-text-intro">
                    {project.title}
                  </IonText>
                  <IonText className="style-text-intro">
                    {project.musicStyle}
                  </IonText>
                </IonRow>
              </NavLink>
            ))}
          </div>
        )}
      </div>
    </>
  );
};
